<script>
    import { itemsForCategory } from "../../scripts/wpn2Model.js";
    import dbData from "../../Stores/utilityDBStore.js";
    import LPBrowseView from "./LPBrowseView.svelte";

    export let searchCat;
    export let detailItem = null;
    let browsableData;
    let actionButtons = [];

    $: browsableData = itemsForCategory(searchCat, $dbData);
    $: actionButtons = setActionButtons();

    function setActionButtons() {
        if ($dbData.user_login_email != undefined) {
            return ["export"];
        }
    }
</script>

<!-- on:export={exportFilteredData} -->
<!-- {filteredData} -->
<!-- on:sort={updateFilteredData} -->
<!-- on:item-select={(event) => (detailItem = event.detail.item)} -->
<div class="left-panel">
    <LPBrowseView
        {searchCat}
        {browsableData}
        {actionButtons}
        {detailItem}
        cellButtonTypes={["Info", "Map"]}
        on:create
        on:find-on-map
        on:close-search-table
        />
</div>

<style>
    .left-panel {
        position: absolute;
        float: left;
        left: 0;
        top: 49px;
        bottom: 0;
        max-width: 512px;
        min-width: 440px;
        font-family: "Source Sans Pro", sans-serif;
        font-size: 0.8rem;
        line-height: 1;
        background-color: #fff;
        border: solid 1px #cfc5c5;
        overflow: scroll;
    }
</style>
